import React, { useRef, useState } from "react";
import "./downloadTemplate.css";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { Calendar } from "primereact/calendar";
import * as XLSX from "xlsx";
import { Toast } from "primereact/toast";
import CommonLoaderBlue from "../../../../../components/Loader/LoaderBlue";
import moment from "moment";
import * as Yup from "yup";
import RenderXlsxTable from "../RenderXlsxTable";
import { api } from "../../../../../../utility/AxiosInceptor";
export default function DownloadTemplate({
  currentSelectedRow,
  isView,
  setCurrentActiveScreen,
  setSelectedAction,
  cpData,
  currentInvoice,
  setCurrentActiveDialog,
}) {
  let toast = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const [viewData, setViewData] = useState(null);
  const [viewColumns, setViewColumns] = useState(null);
  const formik = useFormik({
    validationSchema: Yup.object().shape({
      from: Yup.string().required("This is Required"),
      to: Yup.string().required("This is Required"),
    }),
    initialValues: {
      from: "",
      to: new Date(),
    },
    onSubmit: () => {
      setIsLoading(true);
      let reportTo = formik.values.to
        ? moment(new Date(formik.values.to)).format("MM-DD-YYYY")
        : "";
      let reportFrom = formik.values.from
        ? moment(new Date(formik.values.from)).format("MM-DD-YYYY")
        : "";
      api
        .get(
          `/api/web/reportDownload/download-excel?reportId=${currentSelectedRow?._id}&endDate=${reportTo}&startDate=${reportFrom}`,
          { responseType: "blob" } // Ensure binary response
        )
        .then((response) => {
          const contentDisposition = response.headers["content-disposition"];
          let filename = `Report_(${currentSelectedRow.reportName}_(from_${reportFrom}_to_${reportTo})).xlsx`;
          if (contentDisposition) {
            const match = contentDisposition.match(
              /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/
            );
            if (match) {
              filename = decodeURIComponent(match[1] || match[2]);
            }
          }

          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          setTimeout(() => {
            setCurrentActiveScreen((prev) => ({
              ...prev,
              isDelete: false,
              isEdit: false,
              isDownload: false,
            }));
          }, 1000);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          toast.current.show({
            severity: "error",
            summary: "Download Report",
            detail:
              error?.response?.data?.message || "Report Downloading Failed",
          });
        });
    },
  });
  const handleView = () => {
    const reportTo = formik.values.to
      ? moment(new Date(formik.values.to)).format("MM-DD-YYYY")
      : "";
    const reportFrom = formik.values.from
      ? moment(new Date(formik.values.from)).format("MM-DD-YYYY")
      : "";

    setIsLoading(true);
    api
      .get(
        `/api/web/reportDownload/download-excel?reportId=${currentSelectedRow?._id}&endDate=${reportTo}&startDate=${reportFrom}`,
        { responseType: "blob" }
      )
      .then((response) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

          const headers = jsonData[0];
          const rows = jsonData.slice(1);

          setViewColumns(headers);
          setViewData(
            rows.map((row) =>
              Object.fromEntries(headers.map((header, i) => [header, row[i]]))
            )
          );
          setIsLoading(false);
        };
        reader.readAsArrayBuffer(response.data);
      })
      .catch((error) => {
        setIsLoading(false);
        toast.current.show({
          severity: "error",
          summary: "View Report",
          detail: error?.response?.data?.message || "Failed to load report",
        });
      });
  };
  return (
    <>
      <div
        style={{
          position: "fixed",
          zIndex: 9999,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#FFFFFF99",
          top: 0,
          left: 0,
        }}
      ></div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
        }}
        id="download-template-main"
        className="download-template-main flex flex-wrap flex-row justify-content-center"
      >
        <div className="main-download-invoice">
          <div className="top-header-downloadinvoice">
            <h1>Download Template</h1>
            <p>Select a date range to generate your report.</p>
          </div>
          <div className="date-selector">
            <div className="input-container-customerprofile-customerprofile">
              <div className="w-full flex flex-wrap flex-row justify-content-between align-items-center">
                <label>From</label>
                {formik.touched.from && formik.errors.from && (
                  <label>{formik.errors.from}</label>
                )}
              </div>

              <Calendar
                className={`  customer-dob-main ${formik.touched.from && formik.errors.from ? "p-invalid" : ""}`}
                onChange={formik.handleChange}
                name="from"
                placeholder="Select Date"
                value={formik.values.from}
              />
            </div>{" "}
            <div className="input-container-customerprofile-customerprofile">
              <div className="w-full flex flex-wrap flex-row justify-content-between align-items-center">
                <label>To</label>
                {formik.touched.to && formik.errors.to && (
                  <label>{formik.errors.to}</label>
                )}
              </div>

              <Calendar
                className={` customer-dob-main ${formik.touched.to && formik.errors.to ? "p-invalid" : ""}`}
                onChange={formik.handleChange}
                name="to"
                placeholder="Select Date"
                value={formik.values.to}
              />
            </div>{" "}
          </div>
          <div className="action-buttons flex flex-wrap flex-row justify-content-between aligbn-item-center">
            <Button
              type="button"
              disabled={isLoading}
              onClick={() => {
                setCurrentActiveScreen((prev) => ({
                  ...prev,
                  isDelete: false,
                  isEdit: false,
                  isDownload: false,
                  isView: false,
                }));
              }}
              label="Cancel"
            />
            {isView && (
              <Button
                type="button"
                disabled={isLoading}
                onClick={handleView}
                label={
                  isLoading ? (
                    <div className="flex flex-wrap flex-row justify-content-center align-items-center">
                      <CommonLoaderBlue sizehere="12" color="white" />{" "}
                    </div>
                  ) : (
                    "View"
                  )
                }
              />
            )}
            {!isView && (
              <Button
                type="Submit"
                disabled={isLoading}
                label={
                  isLoading ? (
                    <div className="flex flex-wrap flex-row justify-content-center align-items-center">
                      <CommonLoaderBlue sizehere="12" color="white" />{" "}
                    </div>
                  ) : (
                    "Download"
                  )
                }
              />
            )}
          </div>
        </div>

        <Toast ref={toast} />
      </form>
      {viewData && viewColumns && (
        <RenderXlsxTable
          setViewData={setViewData}
          columns={viewColumns}
          data={viewData}
        />
      )}
    </>
  );
}
